import React from "react";

import currencyFormatter from "../../../helpers/currencyFormatter";
import formatStage from "../../../helpers/format-stage";
import { isOfrStageIncomplete as isIncompleteStage } from "./verification-status";

const fetDisplay = (ofr) => {
  if (!ofr.fet || (!ofr.fet.label && !ofr.fet.amount)) return "N/A";
  return `${ofr.fet.label || "N/A"} - ${currencyFormatter.format(
    ofr.fet.amount || 0,
  )}`;
};

const openL2 = (path) => window.open(path, "_blank", "noopener,noreferrer");

const OfrsBlock = ({ tripId, trip, readOnly }) => {
  const ofrs = trip?.operatorFinancialRecords || [];
  const hasIncomplete = ofrs.some((o) => isIncompleteStage(o.stage));

  return (
    <div className="tv-block tv-ofrs">
      <div className="tv-block-header">
        <h5 className="tv-block-title">
          OFRs
          {hasIncomplete && <span className="tv-text-danger"> - Incomplete</span>}
        </h5>
        {!readOnly && (
          <div className="tv-block-actions">
            <button
              type="button"
              className="base-button icon-button-small evo-blue"
              onClick={() => openL2(`/trips/${tripId}?tab=ofr`)}
              title="Add New OFR"
            >
              <span className="material-icons">add_circle</span>

            </button>
          </div>
        )}
      </div>

      <div className="tv-block-body">
        {ofrs.length === 0 ? (
          <div className="tv-empty">No OFRs are available.</div>
        ) : (
          <table className="tv-table">
            <thead>
              <tr>
                <th>View</th>
                <th>Operator</th>
                <th>Aircraft</th>
                <th>Paid to Operator</th>
                <th>FET - Evo Owes</th>
                <th>Stage</th>
              </tr>
            </thead>
            <tbody>
              {ofrs.map((ofr) => (
                <tr key={ofr._id}>
                  <td>
                    <a
                      href={`/trips/${tripId}/financials/${ofr._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ofr.ofrTag}
                    </a>
                  </td>
                  <td>{ofr.operator?.name || "N/A"}</td>
                  <td>{ofr.aircraft?.name || "N/A"}</td>
                  <td>{currencyFormatter.format(ofr.operatorPrice)}</td>
                  <td>{fetDisplay(ofr)}</td>
                  <td
                    className={isIncompleteStage(ofr.stage) ? "tv-text-danger" : ""}
                  >
                    {formatStage(ofr.stage)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default OfrsBlock;
